var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTelegram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 31,
    viewBox: "0 0 36 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.8974 2.74781L30.4647 28.3684C30.0545 30.1763 28.986 30.6263 27.4674 29.7751L19.1891 23.675L15.1952 27.5172C14.7529 27.9595 14.3838 28.3285 13.5313 28.3285L14.1267 19.8985L29.4681 6.03573C30.1355 5.44167 29.3228 5.11121 28.4318 5.70656L9.46545 17.6495L1.3003 15.0933C-0.47546 14.5391 -0.507606 13.3175 1.67063 12.465L33.6073 0.160682C35.086 -0.393519 36.3796 0.48986 35.8974 2.7491V2.74781Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/telegram.75ef865dd5a202344b04a53ae75a509c.svg";
export { ForwardRef as ReactComponent };